module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_oval_black.e74f0940.png";